<template>
  <transition name="alert">
    <div
      v-if="user.login.isLogin && !user.login.firebaseToken && !helper.isNative.app && user.login.isChecked.hasToken && isShow"
      :class="s.wrap">
      <div class="bg" :class="s.bg" />
      <div
        :class="s.content"
        class="content">
        <div :class="s.message">ログインチェック時にエラーが発生しました。下のボタンより再試行してください。（再試行してもエラーが発生する場合には管理者へお問合せください。）</div>
        <button
          :class="s.btn"
          @click="retryGetFbToken"
          type="button">再試行</button>
        <!-- <button
          :class="s.btn"
          class="mt-2"
          @click="logout"
          type="button">ログアウト</button> -->
        <button
          :class="s.btn"
          class="mt-2"
          @click="isShow = false"
          type="button">閉じる</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'alert',
  data() {
    return {
      isShow: true,
    };
  },
  computed: {
    ...mapState(['helper', 'user']),
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    async retryGetFbToken() {
      this.showLoading();
      await this.$store.dispatch('user/login/initPushNotification', this.user);
      this.hideLoading();
    },

    logout() {
      this.$store.dispatch('user/login/logout');
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-enter-active, .alert-leave-active {
  transition: .3s;
  .content {
    transition: transform .3s;
  }
  .bg {
    transition: opacity .3s;
  }
}

.alert-enter-to, .alert-leave-from {
  .content {
    transform: translateY(0)
  }
  .bg {
    opacity: 1;
  }
}

.alert-enter-from, .alert-leave-to {
  .content {
    transform: translateY(calc(-100% - 12px));
  }
  .bg {
    opacity: 0;
  }
}
</style>

<style lang="scss" module="s">
.wrap {
  z-index: 15;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0; left: 0;
}
.bg {
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(#000000, .2);
}
.content {
  position: fixed;
  z-index: 2;
  top: var(--page-label-height);
  left: 0;
  width: 100%;
  background-color: var(--primary-red);
  color: #ffffff;
  padding: 12px;
}
.message {
  flex: 1;
  margin-bottom: 12px;
}
.btn {
  border: 1px solid #ffffff;
  width: 100%;
  color: #ffffff;
  background-color: var(--primary-red);
  padding: 4px 8px;
}
</style>
